import { I18n } from 'react-redux-i18n';

const buildingsSearchFields = (searchFieldValues, parentList) => {
    return {
        rows: [{
            hasTopBreak: false,
            hasBottomBreak: false,
            fields: [
                {
                    id: "name",
                    label: I18n.t('entities.list.name'),
                    type: "text",
                    value: searchFieldValues.name.value,
                },
                {
                    id: "parentId",
                    label: I18n.t('entities.types.company'),
                    type: "dropdown",
                    value: searchFieldValues.parentId.value,
                    data: parentList,
                    validator: () => { }
                }
            ]
        },
        ]
    }
};

export {
    buildingsSearchFields
}